import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "./index.css";
import "./font.css";
import ScrmRoutes from "./Routes";
import { Provider } from "react-redux";
import store from "./store";
import { OidcProvider } from "./context/oidc/OidcContext";
import { AuthProvider } from "./context/auth/AuthContext";
import { ToastContainer } from "@/components/Common/Toast/Toast";
import ErrorBoundary from "./components/ErrorBoundary";

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ErrorBoundary>
          <OidcProvider>
            <AuthProvider>
              <ToastContainer />
              <ScrmRoutes />
            </AuthProvider>
          </OidcProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
